/**
 * Enum representing supported currency types
 */
export enum Currency {
  EUR = "EUR",  // Euro currency
  TRY = "TRY",  // Turkish Lira
  USD = "USD"   // US Dollar
}

/**
 * Enum representing supported locales/languages
 */
export enum Locale {
  de_DE = "de",    // German
  en_US = "en",    // English
  tr_TR = "tr"     // Turkish
}

/**
 * Default currencies for the locales
 */
export const DEFAULT_CURRENCIES: Record<Locale, Currency> = {
  [Locale.de_DE]: Currency.EUR,
  [Locale.en_US]: Currency.USD,
  [Locale.tr_TR]: Currency.TRY
};

/**
 * Default locale for the application
 */
export const DEFAULT_LOCALE: Locale = Locale.tr_TR;